require('../../vendor/psagroupeuk/theme/resources/theme/psagroupe/js/theme');

// dropzone
window.dropzone = require('dropzone')
Dropzone.autoDiscover = false;


//load plugins
require('./plugins/savy.min');
require('../../vendor/snapappointments/bootstrap-select/js/bootstrap-select');
